import { Component, OnInit, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ButtonConfig, buttonsStaticConfig, RoutesEnum} from '../../../global';
import {Observable} from 'rxjs';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {map} from 'rxjs/operators';
import { DialogContainerComponent } from '../../components/dialog-container/dialog-container.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
    selector: 'slm-help-dialog',
    templateUrl: './help-dialog.component.html',
    imports: [DialogContainerComponent, NgIf, LoaderComponent, AsyncPipe]
})
export class HelpDialogComponent implements OnInit {
  readonly dialogRef = inject<MatDialogRef<HelpDialogComponent>>(MatDialogRef);
  private sanitized = inject(DomSanitizer);
  data = inject<Observable<string>>(MAT_DIALOG_DATA);

  public readonly buttons: Array<ButtonConfig> = [
    buttonsStaticConfig.close,
    {
      action: 'navigate',
      url: RoutesEnum.BUG_REPORT,
      buttonStyle: 'primary',
      label: 'BUG_REPORT.TITLE_SHORT',
      testId: 'bug-report-btn'
    }
  ];

  public content$: Observable<SafeHtml>;

  ngOnInit() {
    this.content$ = this.data.pipe(map(content => this.sanitized.bypassSecurityTrustHtml(content)));
  }

  public buttonEvent() {
    this.dialogRef.close();
  }
}
